/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 캘린더 관련 상태관리 컴포넌트
 * 버전 : 1.0
 * 파일명 : RecruitStore.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================
 * 수정 : 2026-01-13, 강동형 : 축제관련 상태값 추가
 * 수정 : 2026-02-04, 강동형 : 축제관련 미사용 데이터 제거
 * 수정 : 2026-02-05, 강동형 : 축제등록관련 Dialog사용값 추가
 *================================================================*/

import { ArmyRecruitDataType } from 'src/components/recruitment/LoadArmyRecruit'
import {create} from'zustand'

type DialogState = "축제 정보" | "모집 일정" | "축제 등록";

interface RecruitStore{
    year : string
    month : string
    type:string
    status:string
    isOpen : boolean
    dialogCurrentDate : Date | null,
    dialogData : any,
    ArmyRecruitData : ArmyRecruitDataType[]
    selected : any,
    dialogState : DialogState
    dialogStartDate : Date | string | null;
    dialogEndDate : Date | string | null;
    modifyProps : any
    setField : (field: keyof RecruitStore, value: any) => void 
    reset: (field?: keyof RecruitStore) => void
}

const today = new Date();

const defaultValue = {
    year: today.getFullYear().toString(),
    month: (today.getMonth() + 1).toString(),
    type:'모집유형',
    status:'상태',
    isOpen: false,
    dialogCurrentDate: null,
    dialogData: [],
    ArmyRecruitData : [],
    selected: null,
    dialogState: '모집 일정' as DialogState,
    dialogStartDate : null,
    dialogEndDate : null,
    modifyProps: []
}

export const useRecruitStore = create<RecruitStore>((set)=>({
    ...defaultValue,
    setField : (field,value)=>set((state)=>({...state,[field]:value})),
    reset: (field) =>
        set((state) => {
            if (!field) {
                // 전체 초기화
                return { ...state, ...defaultValue }
            }
            // 특정 필드만 초기화
            return { ...state, [field]: defaultValue[field as keyof typeof defaultValue] }
        }),
}))